import AdminContentListAIGeneratedFilter from "@/admin/content-library/filters/AdminContentListFilterAIGenerated"
import { AdminContentListToolbarState } from "@/admin/content-library/filters/AdminContentListToolbar"
import { useLabel } from "@/core/context/LabelsContext"
import CollectionFilterDropdown from "@components/dropdown/collection/CollectionFilterDropdown"
import ContentLabelFilterDropdown from "@components/dropdown/content-label/ContentLabelFilterDropdown"
import ProductFilterDropdown from "@components/dropdown/product/ProductFilterDropdown"
import { DiscoButton, DiscoDropdown } from "@disco-ui"
import { TestIDProps } from "@utils/typeUtils"
import AdminContentListInstancesFilter from "./AdminContentListInstancesFilter"

interface AdminContentListFilterDropdownProps extends TestIDProps {
  toolbarState: AdminContentListToolbarState
  setToolbarState: React.Dispatch<React.SetStateAction<AdminContentListToolbarState>>
  hideProduct?: boolean
  hideCollection?: boolean
  hideAIGenerated?: boolean
}

function AdminContentListFilterDropdown({
  testid,
  toolbarState,
  setToolbarState,
  hideProduct = false,
  hideCollection = false,
  hideAIGenerated = false,
}: AdminContentListFilterDropdownProps) {
  const experienceLabel = useLabel("admin_experience")

  return (
    <DiscoDropdown
      menuButton={(btnProps) => (
        <DiscoButton {...btnProps} testid={`${testid}.filter-select.header-button`}>
          {"Filters"}
        </DiscoButton>
      )}
    >
      <ContentLabelFilterDropdown
        testid={"AdminContentList.label-select"}
        title={"Label"}
        filterState={toolbarState}
        setFilterState={(newToolbarState) =>
          setToolbarState({
            ...toolbarState,
            ...newToolbarState,
          })
        }
      />

      {!hideProduct && (
        <ProductFilterDropdown
          testid={"AdminContentList.product-select"}
          title={experienceLabel.plural}
          hideCommunityOption
          filterState={toolbarState}
          setFilterState={(newToolbarState) =>
            setToolbarState({
              ...toolbarState,
              ...newToolbarState,
            })
          }
        />
      )}

      {!hideCollection && (
        <CollectionFilterDropdown
          testid={"AdminContentList.collection-select"}
          title={"Collection"}
          filterState={toolbarState}
          setFilterState={(newToolbarState) =>
            setToolbarState({
              ...toolbarState,
              ...newToolbarState,
            })
          }
        />
      )}

      <AdminContentListInstancesFilter
        filterState={toolbarState}
        setFilterState={(newFilterState) =>
          setToolbarState({ ...toolbarState, ...newFilterState })
        }
      />

      {!hideAIGenerated && (
        <AdminContentListAIGeneratedFilter
          filterState={toolbarState}
          setFilterState={(newFilterState) =>
            setToolbarState({ ...toolbarState, ...newFilterState })
          }
        />
      )}
    </DiscoDropdown>
  )
}

export default AdminContentListFilterDropdown
